import { SlatePlugin } from '../../slatePlugins.types';
import { DeserializeHTMLReturn } from '../types';
import { deserializeHTMLNode } from './deserializeHTMLNode';

/**
 * Deserialize HTML element.
 */
export const deserializeHTMLElement = ({
  plugins,
  element,
}: {
  plugins: SlatePlugin[];
  element: HTMLElement;
}): DeserializeHTMLReturn => {
  return deserializeHTMLNode(plugins)(element);
};
